"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.storefrontVisited = void 0;
var constants_1 = require("../constants");
exports.storefrontVisited = function (_a) {
    var _b, _c;
    var session = _a.session, storefront = _a.storefront, cart = _a.cart;
    var cartProps = cart
        ? (_b = {},
            _b[constants_1.EventProperty.CART_PRODUCT_CATEGORIES] = cart.categories,
            _b[constants_1.EventProperty.CART_PRODUCT_IDS] = cart.ids,
            _b[constants_1.EventProperty.CART_PRODUCT_NAMES] = cart.names,
            _b[constants_1.EventProperty.CART_PRODUCT_SKUS] = cart.skus,
            _b[constants_1.EventProperty.CART_SIZE] = cart.size,
            _b[constants_1.EventProperty.CART_VALUE] = cart.value,
            _b[constants_1.EventProperty.PRELOADED_CART_TYPE] = cart.preloadedType,
            _b) : {};
    var props = __assign((_c = {}, _c[constants_1.EventProperty.CURRENCY] = storefront.currency, _c[constants_1.EventProperty.USER_ID] = session.userID, _c[constants_1.EventProperty.CUSTOMER_NAME] = session.customer, _c), cartProps);
    window.analytics.page(constants_1.EventName.STOREFRONT_VISITED, props);
};
